<template>

	<div class="row lobby-article">

		<div class="col-xs-12" v-show="!article.loading">

			<div class="article-body">

				<div class="col-xs-12 mb15">

					<div class="text-right">
						<button class="btn btn-primary"  @click.stop.prevent="$router.push('/cgd/by/article/edit/'+article.id)">
							<i class="fa fa-pencil"></i>
							编辑
						</button>
					</div>


					<div class="text-right mt15">

						<span class="mr10">
							标题：{{article.title}}
						</span>

						<span class="mr10">
							点击: {{article.hit}}
						</span>
								<span class="mr10">
							作者: {{article.author}}
						</span>
								<span class="mr10">
							发布于: {{article.releaseTime | simpleDate}}
						</span>


					</div>
				</div>


				<div v-html="article.content">

				</div>


			</div>


		</div>
		<div class="col-xs-12 text-center mt40" v-show="article.loading">
			<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
		</div>
	</div>

</template>

<script>

	import Article from "../../../../common/model/article/Article";
	export default {
		props: {
			article: {
				type: Article,
				required: true
			}
		},
		data () {
			return {
				user: this.$store.state.user
			}
		},
		computed: {},
		components: {},
		watch: {},
		methods: {},
		mounted(){
		}
	}

</script>


<style lang="less" rel="stylesheet/less">

	.lobby-article {
		.article-body {

			padding: 20px 20px;
			-webkit-border-radius: 5px;
			-moz-border-radius: 5px;
			border-radius: 5px;
			background-color: white;

		}
		img {
			max-width: 100%;
		}
	}


</style>




// WEBPACK FOOTER //
// ArticleView.vue?2a7c49e4